// extracted by mini-css-extract-plugin
export var copyableField = "_rg-4";
export var customerBadge = "_rg-0";
export var customerInfoTitle = "_rg-2";
export var details = "_rg-1";
export var dropdownContainer = "_rg-5";
export var dropdownImage = "_rg-6";
export var editAssigneeForm = "_rg-a";
export var editButton = "_rg-3";
export var email = "_rg-7";
export var hidden = "_rg-d";
export var input = "_rg-8";
export var saveButton = "_rg-b";
export var shopifyIcon = "_rg-c";
export var suggestionBadge = "_rg-e";
export var suggestionText = "_rg-f";
export var username = "_rg-9";